/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_2_AInputs */

const en_cp_faq_2_a = /** @type {(inputs: Cp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every task has an assignee, evidence, and a timestamp. The phase-approval log records who did what. An audit export is available for an individual-contribution rubric.`)
};

const id_cp_faq_2_a = /** @type {(inputs: Cp_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap task punya assignee, bukti, dan waktu. Log persetujuan fase mencatat siapa mengerjakan apa. Ekspor audit tersedia untuk rubrik kontribusi individu.`)
};

/**
* | output |
* | --- |
* | "Every task has an assignee, evidence, and a timestamp. The phase-approval log records who did what. An audit export is available for an individual-contributi..." |
*
* @param {Cp_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_2_a = /** @type {((inputs?: Cp_Faq_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_2_a(inputs)
	return en_cp_faq_2_a(inputs)
});